import { auxiliaryFieldsDefaultValues, auxiliaryFieldsTransormers } from '../Filters/auxiliaryFields';
import { filterFields } from '../Filters/FilterFields/dataExplorerFieldsConfig';
import {
  DateTimeRangeFieldTransformer,
  GenericFieldTransformer,
  RangeFieldTransformer,
} from '../Filters/FieldTransformers/FieldTransformers';
import { regionDefaultValues, regionTransformers } from '../Filters/FilterFields/RegionGroup';
import { DatasetsFormFields } from './types';
import { commonFieldTransformers } from '../CommonDataFieldsSelector/CommonDataFieldsSelector';

export const DatasetsFilterDefaultValues: DatasetsFormFields = {
  search: filterFields.search.defaultValue,
  valueScore: filterFields.valueScore.defaultValue,
  alphaCount: filterFields.alphaCount.defaultValue,
  category: filterFields.category.defaultValue,
  subcategory: filterFields.subcategory.defaultValue,
  theme: filterFields.theme.defaultValue,
  dateUpdated: filterFields.dateUpdated.defaultValue,
  ...regionDefaultValues,
  ...auxiliaryFieldsDefaultValues,
};

export const DatasetsFiltersTransformers = [
  new GenericFieldTransformer(filterFields.search.name),
  new RangeFieldTransformer(filterFields.valueScore.name),
  new RangeFieldTransformer(filterFields.alphaCount.name),
  new GenericFieldTransformer(filterFields.category.name),
  new GenericFieldTransformer(filterFields.subcategory.name),
  new GenericFieldTransformer(filterFields.theme.name),
  new DateTimeRangeFieldTransformer(filterFields.dateUpdated.name),
  ...commonFieldTransformers,
  ...regionTransformers,
  ...auxiliaryFieldsTransormers,
];
